"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bus_http_1 = require("@comunica/bus-http");
const stringifyStream = require("stream-to-string");
/**
 * A JSON-LD document loader that fetches over an HTTP bus using a given mediator.
 */
class DocumentLoaderMediated {
    constructor(mediatorHttp, context) {
        this.mediatorHttp = mediatorHttp;
        this.context = context;
    }
    async load(url) {
        const response = await this.mediatorHttp.mediate({ input: url, init: { headers: new Headers({ accept: 'application/ld+json' }) }, context: this.context });
        if (response.ok) {
            return JSON.parse(await stringifyStream(bus_http_1.ActorHttp.toNodeReadable(response.body)));
        }
        else {
            throw new Error(`No valid context was found at ${url}: ${response.statusText}`);
        }
    }
}
exports.DocumentLoaderMediated = DocumentLoaderMediated;
//# sourceMappingURL=DocumentLoaderMediated.js.map